export function BrandCapitalHero() {
  return (
    <section className="relative min-h-screen flex items-center bg-white overflow-hidden">
      <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row">
        {/* Area Sinistra - Contenuto */}
        <div className="w-full lg:w-2/5 bg-slate-900 min-h-screen flex flex-col justify-center px-6 sm:px-8 lg:px-12 py-12 lg:py-20">
          <div className="max-w-lg">
            <div className="inline-block bg-green-500 text-white text-sm font-semibold px-4 py-2 rounded-full mb-6">
              CHI SIAMO
            </div>
            
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-6">
              Brand Capital: Il tuo Partener nella Valutazione del Brand
            </h1>
            
            <p className="text-base lg:text-lg text-white/90 leading-relaxed">
              L'unica metodologia che integra tutti gli indicatori esistenti per creare perizie veritiere, 
              difendibili e certificate. Brand Capital trasforma la valutazione del brand da opinione 
              soggettiva a dato oggettivo registrato a bilancio, verificabileche supporta ogni decisione strategica con dati 
              e documentazione completa.
            </p>
          </div>
        </div>
        
        {/* Area Destra - Immagine */}
        <div className="w-full lg:w-3/5 relative h-64 sm:h-96 lg:h-screen">
          <div className="absolute inset-0 bg-gradient-to-l from-transparent via-slate-900/5 to-slate-900/20"></div>
          <img 
            src="https://public.readdy.ai/ai/img_res/2852e1210b87ed02e244e2c3f425e7f7.jpg"
            alt="Team Brand Capital al lavoro su analisi professionali"
            className="w-full h-full object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}